import {Mapper} from '@s-ui/domain'

export class FromFormParamsToSearchUrlFormValueObjectMapper extends Mapper {
  constructor({searchUrlFormValueObjectFactory, toQueryString}) {
    super()
    this._searchUrlFormValueObjectFactory = searchUrlFormValueObjectFactory
    this._toQueryString = toQueryString
  }

  setParams({apiUrl, dataSource, nextField, requestParams}) {
    this._apiUrl = apiUrl
    this._dataSource = dataSource
    this._nextField = nextField
    this._requestParams = requestParams
  }

  map = () => {
    if (this._nextField === 'engines') this._nextField = 'versions/info'
    if (this._dataSource) {
      if (this._nextField === 'bodytypes') this._nextField = 'body-types'
      if (this._nextField === 'fuels') this._nextField = 'fuel-types'
      if (this._requestParams.bodyTypeDoors) {
        const {bodyTypeDoors, ...rest} = this._requestParams
        const [bodyTypeId, doors] = bodyTypeDoors.split('-')
        this._requestParams = {bodyTypeId, doors, ...rest}
      }
    }

    const dataSourcePath = this._dataSource ? `/${this._dataSource}` : ''
    const nextFieldUrl = `${this._apiUrl}/${this._nextField}${dataSourcePath}`
    const queryParams = this._toQueryString(this._requestParams)

    const queryParamsUrl = `?${queryParams}`
    const searchUrl = `${nextFieldUrl}${queryParamsUrl}`

    return this._searchUrlFormValueObjectFactory({url: searchUrl})
  }
}
